// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2-T_l","dragIcon":"Choice_dragIcon__wXDyy","left":"Choice_left__3dZHD","input":"Choice_input__2L03s"};